/* tslint:disable */
import { OrganisationController } from "@proxy/OrganisationController";
import { ApplicationState } from "./applicationState";
import { getStoreAccessors } from "vuex-typescript";
import { setVuexKeys } from "@src/store/StoreHelper";
import { ActionContext } from "vuex";
import { AttachmentController } from "@proxy/AttachmentController";

type ApplicationStateContext = ActionContext<ApplicationState, any>;

const ApplicationStore = {
    namespaced: true,
    state: new ApplicationState(),

    mutations: {
        updateCurrentOrganisation(state: ApplicationState, organisation: ProxyModel.OrganisationViewModel) {
            state.organisationShortName = organisation.organisationShortName;
        },
        updateIsOfba(state: ApplicationState, isOfba: boolean) {
            state.isOfba = isOfba;
        },
        updateSideBarMiniState(state: ApplicationState, value: boolean): void {
            state.isSideBarMiniActive = value;
        },
        updateMaxFileSizeAllowConfig(state: ApplicationState, value: ProxyModel.MaxFileSizeConfigModel): void {
            state.maxFileSizeAllowConfig = value;
        },
        updateReturnUrlHash(state: ApplicationState, value: string): void {
            state.returnUrlHash = value;
        },
    },
    getters: {
        isOfba: (state: ApplicationState) => {
            return state.isOfba;
        },
        isSideBarMiniActive: (state: ApplicationState) => {
            return state.isSideBarMiniActive;
        },
        getReturnUrlHash: (state: ApplicationState) => {
            return state.returnUrlHash;
        }
    },
    actions: {
        getCurrentOrganisationShortName: async (store: ApplicationStateContext) => {
            if (store.state.organisationShortName) {
                return Promise.resolve(store.state.organisationShortName);
            }
            const response = await new OrganisationController().getCurrentOrganisation();

            if (response.isSuccessful) {
                store.commit("updateCurrentOrganisation", response.successData);
                return response.successData.organisationShortName;
            }
            return "";
        },
        getMaxFileSizeAllowConfig: async  (store: ApplicationStateContext) => {
            if (store.state.maxFileSizeAllowConfig) {
                return Promise.resolve(store.state.maxFileSizeAllowConfig);
            }
            const response = await new AttachmentController().getMaxFileSizeAllowConfig();

            if (response.isSuccessful) {
                store.commit("updateMaxFileSizeAllowConfig", response.successData);
                return response.successData;
            }
            return null;
        }
    }
};

export default ApplicationStore;

const { commit, dispatch, read } = getStoreAccessors<ApplicationState, any>("applicationStore");

const actions = setVuexKeys(ApplicationStore.actions);
export const getCurrentOrganisationShortName = dispatch(actions.getCurrentOrganisationShortName);
export const getMaxFileSizeAllowConfig = dispatch(actions.getMaxFileSizeAllowConfig);

const mutations = setVuexKeys(ApplicationStore.mutations);
export const updateIsOfba = commit(mutations.updateIsOfba);
export const updateSideBarMiniState = commit(mutations.updateSideBarMiniState);
export const updateReturnUrlHash = commit(mutations.updateReturnUrlHash);

const getters = setVuexKeys(ApplicationStore.getters);
export const isOfba = read(getters.isOfba);
export const isSideBarMiniActive = read(getters.isSideBarMiniActive);
export const getReturnUrlHash = read(getters.getReturnUrlHash);